module.exports = __webpack_public_path__ + "static/logo-creaith-62f96b6b95b51758af2abc027b979810.svg";